import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { Dropdown } from 'primeng/dropdown';
import { RequestStatusEnum } from 'src/app/Enums/RequestStatusEnum';
import { GerinusBD } from 'src/app/app-core/lib/gerinus-bd.component';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { CryptoService } from 'src/app/app-core/services/crypto.service';
import { FilterService, ICitizenFilters, ICitizenStatuses, IProcessFilterStatuses} from 'src/app/app-core/services/filter.service';
import { OrganizationService } from 'src/app/app-core/services/organization.service';
import { PersonService } from 'src/app/app-core/services/person.service';
import { ProcessService } from 'src/app/app-core/services/process.service';
import { RequestService } from 'src/app/app-core/services/request.service';
import { RequestHistoryService } from 'src/app/app-core/services/requestHistory.service';
import { SubjectService } from 'src/app/app-core/services/subject.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { IRequestStatuses } from 'src/app/interfaces/request.interface';
import { IGetEntityProccessResponse } from 'src/app/interfaces/getEntity/getEtityProccessResponse';
import { format } from 'date-fns';
import { ProcessStatusEnum } from 'src/app/Enums/ProcessStatusEnum';
import { ProccessHistoryService } from 'src/app/app-core/services/proccessHistorory.service';
import {
  IRqStatus,
  REQUEST_BUCKET_CONDITIONS,
  REQUEST_STAGES,
  RequestBucketEnum,
  citizenStatus,
  orgIcon,
  requestStage,
} from 'src/app/app-core/lib/request-status';
import { ICitizenOverview, ICitizenOverviewPending } from 'src/app/interfaces/request-ui';

type CitizenTab = RequestBucketEnum | 'todas';

@Component({
  selector: 'app-citizen',
  templateUrl: './citizen.component.html',
  styleUrls: ['./citizen.component.scss'],
  providers: [
    RequestService,
    RequestHistoryService,
    ProccessHistoryService,
    UserService,
    PersonService,
    OrganizationService,
    ProcessService,
    MessageService,
    SubjectService,
    FilterService,
    GlobalService
],
})
export class CitizenComponent extends GerinusBD implements OnInit, OnDestroy {
  @ViewChild('subjectDropdown') subjectDropdown: Dropdown;
  @ViewChild('pendingClose') pendingClose: ElementRef<HTMLButtonElement>;

  @Input() title: string;
  @Input() buttonLabel: string;
  @Input() owner: string;
  @Input() showFilter = true
  @Input() customMarginTop: string;


  public isTableHistoryOpen: boolean[] = [];
  public typeRequestParam: string;
  public historics: any[] = [];
  public history: any[] = [];
  public today: Date = new Date();
  public customCitizen: string;
  public customTitle: string = 'Sistema de Protocolo Eletrônico';
  public createdAtRange: Date[] | undefined;
  public button: string
  public citizenFilters: ICitizenFilters
  public processCitizen: string;
  public statusCitizen: ICitizenStatuses[];

  //FILTROS
  public requestStatuses: IRequestStatuses[];
  public citizenStatuses: ICitizenStatuses[];
  public selectedStatuses: IRequestStatuses[];
  public citizenProcessStatuses: IProcessFilterStatuses[];
  public processStatuses: IProcessFilterStatuses[];
  public requestNumber: string;
  public requester: string;
  public selectedSubject: string;
  public isFiltersModalOpen: boolean = false;
  public isFiltersModalResponsiveOpen: boolean = false;
  private lastFilterParamKey: string | null = null;

  // ABAS E RESUMO
  public readonly tabs: Array<{ key: CitizenTab; label: string }> = [
    { key: 'todas', label: 'Todas' },
    { key: RequestBucketEnum.ANDAMENTO, label: 'Em andamento' },
    { key: RequestBucketEnum.ACAO, label: 'Precisam de você' },
    { key: RequestBucketEnum.CONCLUIDAS, label: 'Concluídas' },
    { key: RequestBucketEnum.ENCERRADAS, label: 'Encerradas' },
  ];
  public activeTab: CitizenTab = 'todas';
  public overview: ICitizenOverview | null = null;
  public readonly stages = REQUEST_STAGES;
  /** Modal com as solicitações e processos que esperam uma ação do cidadão. */
  public pendingOpen = false;

  constructor(
      public requestService: RequestService,
      public global: GlobalService,
      private activatedRoute: ActivatedRoute,
      private historicService: RequestHistoryService,
      public processHistoryService: ProccessHistoryService,
      public userService: UserService,
      public personService: PersonService,
      private cryptoService: CryptoService,
      private processService: ProcessService,
      private messageService: MessageService,
      private config: PrimeNGConfig,
      private router: Router,
      private filterService: FilterService
  ) {
      super(global, requestService);
      this.syncPageWithUrl = true;
  }

ngOnInit() {
    this.config.setTranslation({
        apply: 'Aplicar',
        clear: 'Limpar',
        accept: 'Sim',
        reject: 'Não',
        firstDayOfWeek: 0,
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
        dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
            'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje'
    });


    this.loadOverview();

    this.activatedRoute.queryParams.subscribe(params => {
        this.owner = params['owner'] || '';
        this.processCitizen = params['processCitizen'] || '';
        this.activeTab = this.parseTab(params['aba']);
    
        if (typeof params['dateRange'] === 'string' && params['dateRange'] !== '') {
          this.createdAtRange = params['dateRange'].split(',').map(date => new Date(date));
        }

        else {
          this.createdAtRange = [];
        }

        if (typeof params['statusCitizen'] === 'string' && params['statusCitizen'] !== '') {
          const statusArray = params['statusCitizen'].includes(',') ? params['statusCitizen'].split(',') : [params['statusCitizen']];

          this.selectedStatuses = this.requestStatuses && this.requestStatuses.length > 0
              ? statusArray.map(value => {
                  return this.requestStatuses.find(status => status.value === +value);
              }).filter(status => status !== undefined)
              : [];
      } else {
          this.selectedStatuses = [];
      }

      if (typeof params['statuses'] === 'string' && params['statuses'] !== '') {
        const statusArray = params['statuses'].includes(',') ? params['statuses'].split(',') : [params['statuses']];

        this.citizenProcessStatuses = this.processStatuses && this.processStatuses.length > 0
            ? statusArray.map(value => {
                return this.processStatuses.find(status => status.value === +value);
            }).filter(status => status !== undefined)
            : [];
      } else {
          this.citizenProcessStatuses = [];
      }
      const filterParamsKey = JSON.stringify({ ...params, [this.pageParam]: undefined });
      const onlyPageChanged = this.lastFilterParamKey === filterParamsKey;
      this.lastFilterParamKey = filterParamsKey;

      if (!onlyPageChanged) {
        this.listAll();
      }
    });

    this.requestStatuses = this.getStatusesByParam();

    this.customCitizen = this.userService.isCidadao()
      ? 'mt-4 mt-md-5 mt-lg-5'
      : 'mt-4 mt-md-8 mt-lg-8';

      this.processStatuses = [
        { name: 'Novo', value: 1 },
        { name: 'Em Andamento', value: 2 },
        { name: 'Arquivado', value: 3 },
        { name: 'Concluído', value: 4 },
        { name: 'Aguardando ajuste do cidadão', value: 5 },
        { name: 'Vencido', value: 6 },
        { name: 'Anulado', value: 7 },
        { name: 'Respondido', value: 8 },
        { name: 'Vencido sem Análise', value: 9 },
        { name: 'Aguardando restituição', value: 10 },
        { name: 'Aguardando pagamento', value: 12 },
        { name: 'Aguardando assinatura do Secretário', value: 14 }
    ];

}

getStatusesByParam() {

  return [
      { name: 'Triagem', value: 0 },
      { name: 'Aceitas', value: 1 },
      { name: 'Em Correção', value: 2 },
      { name: 'Anuladas', value: 3 },
      { name: 'Vencidas', value: 5 },
      { name: 'Aguardando Assinatura', value: 6 }
  ];
}


public listCondition() {
    const user = this.global.user();
    const personId = user.PE_CodigoPessoa;

    let conditions = `"SOL_CodigoSolicitante" = ${personId}`;

    const tabCondition = this.activeTab !== 'todas' ? REQUEST_BUCKET_CONDITIONS[this.activeTab] : null;

    if (tabCondition) {
      conditions += ` AND ${tabCondition}`;
    }

    const additionalFilters = this.filter();

    if (typeof additionalFilters === 'string') {
      if (additionalFilters) {
        conditions += ` AND ${additionalFilters}`;
      }
    }

    return conditions;
  }

  fetchAllRequestsFiltered() {
    this.syncFiltersToQueryParams();
    this.listAll(1);

    this.isFiltersModalOpen = false;
  }

  filter() {
    this.citizenFilters = {
         owner: this.owner,
         processCitizen: this.processCitizen,
         statusCitizen: this.selectedStatuses ? this.selectedStatuses.map(status => status.value).join(',') : '',
         statuses: this.citizenProcessStatuses ? this.citizenProcessStatuses.map(status => status.value).join(',') : '',
         dateRange: this.createdAtRange ? this.createdAtRange.filter(date => date != null).map(date => date.toISOString()).join(',') : '',
    }

    return this.filterService.getCitizenFilterConditions(this.citizenFilters);
  }

  private syncFiltersToQueryParams(): void {
    this.filter();

    this.router.navigate([], {
         relativeTo: this.activatedRoute,
         queryParams: {
          ...this.citizenFilters,
          [this.pageParam]: null,
         },
         queryParamsHandling: 'merge',
    });
  }

  clearFilters() {
    this.owner = null,
    this.processCitizen = null,
    this.createdAtRange = null,
    this.selectedStatuses = null,
    this.citizenProcessStatuses = null,

    this.router.navigate([], {
         relativeTo: this.activatedRoute,
         queryParams: {},
    });

    this.listAll(1);

    this.isFiltersModalOpen = false;
  }

  get isClearFiltersButtonVisible(): boolean {
    return !!(
      this.processCitizen ||
     (this.createdAtRange && this.createdAtRange.length > 0) ||
      this.owner ||
      (this.selectedStatuses && this.selectedStatuses.length > 0) ||
      (this.citizenProcessStatuses && this.citizenProcessStatuses.length > 0)
    );
  }

  add() {
      this.global.router.navigate(['/requests/new']);
  }


  getHistoricsRequest(requestId: number, index: number) {
    if (this.isTableHistoryOpen[requestId]) {
        this.historics.splice(index, 1);
    } else {
        this.historicService.listAll(`"SOLH_CodigoSolicitacao" = ${requestId}`).subscribe({
            next: (response: any) => {
                this.historics.push({
                    data: response.data,
                    index,
                });
            },
        });
    }
  }

  getHistoryProcess(processoId: number, index: number) {
    if (this.isTableHistoryOpen[processoId]) {
        this.history.splice(index, 1);
    } else {
        this.processHistoryService.listAll(`"PRCH_CodigoProcesso" = ${processoId}`, 0).subscribe({
            next: (response: any) => {
                this.history.push({
                    data: response.data,
                    index,
                });
            },
        });
    }
  }


  historyFilter(index: number) {
    return this.history.filter((history) => {
        return history.index === index;
    });
  }

  historicsFilter(index: number) {
    return this.historics.filter((historico) => {
        return historico.index === index;
    });
  }

  getStatusClass(status: number): any {
    return {
      triagem: status === RequestStatusEnum.evaluation,
      aceita: status === RequestStatusEnum.accepted,
      correcao: status === RequestStatusEnum.correction,
      anulada: status === RequestStatusEnum.canceled,
      corrigida: status === RequestStatusEnum.corrected,
      vencida: status === RequestStatusEnum.outdated,
      'aguardando-assinatura': status === RequestStatusEnum.awaitingSignature,
    };
  }
  
  getStatusDescription(status: number): string {
    const statusDescriptions = {
      [RequestStatusEnum.evaluation]: 'Triagem',
      [RequestStatusEnum.accepted]: 'Aceita',
      [RequestStatusEnum.correction]: 'Correção',
      [RequestStatusEnum.canceled]: 'Anulada',
      [RequestStatusEnum.corrected]: 'Corrigida',
      [RequestStatusEnum.outdated]: 'Vencida',
      [RequestStatusEnum.awaitingSignature]: 'Aguardando Assinatura'
    };
  
    return statusDescriptions[status];
  }
  
  getStatusTooltip(status: number): string {
    const statusTooltips = {
      [RequestStatusEnum.evaluation]:
        'A solicitação está com o Departamento de Triagem e será encaminhado ao setor responsável, caso aprovado.',
      [RequestStatusEnum.correction]:
        'A solicitação requer ajustes. Realize as correções necessárias para prosseguirmos com o atendimento.',
      [RequestStatusEnum.accepted]:
        'A solicitação foi aceita. Você será notificado sobre qualquer atualização.',
      [RequestStatusEnum.corrected]:
        'A solicitação foi corrigida. Clique em “Ver” para detalhes sobre a conclusão.',
      [RequestStatusEnum.canceled]: 
      'Sua solicitação foi anulada. Clique em ”Ver” para consultar o motivo e obter mais detalhes.',
      [RequestStatusEnum.outdated]:
      'A solicitação está vencida.',
      [RequestStatusEnum.awaitingSignature]:
      'A triagem aprovou sua solicitação. Ela aguarda a assinatura do responsável pelo órgão e, assinada, vira processo.'
    };

    return statusTooltips[status];
  }
  
  getProcessClass(status: number): any {
    return {
      Novo: status === ProcessStatusEnum.NEW,
      Andamento: status === ProcessStatusEnum.IN_PROGRESS,
      Arquivado: status === ProcessStatusEnum.ARCHIVED,
      Concluido: status === ProcessStatusEnum.CONCLUDED,
      Correcao: status === ProcessStatusEnum.IN_CORRECTION,
      Vencido: status === ProcessStatusEnum.OUTDATED,
      Anulado: status === ProcessStatusEnum.CANCELED,
      Respondido: status === ProcessStatusEnum.ANSWERED,
      Vencido_sem_Analise: status == ProcessStatusEnum.EXPIRED_WITHOUT_ANALYSIS,
      Aguardando_restituicao: status == ProcessStatusEnum.AWAITING_REFUND,
      Aguardando_pagamento: status == ProcessStatusEnum.AWAITING_PAYMENT,
      Pendente_Atribuicao: status == ProcessStatusEnum.PENDING_WITHOUT_RESPONSIBLE,
      Apensado: status == ProcessStatusEnum.APENSADO,
      Aguardando_assinatura_secretario: status == ProcessStatusEnum.AWAITING_SECRETARY_SIGNATURE
    };
  }
  
  getProcessDescription(status: number): string {
    const statusDescriptions = {
      [ProcessStatusEnum.NEW]: 'Novo',
      [ProcessStatusEnum.IN_PROGRESS]: 'Em Andamento',
      [ProcessStatusEnum.ARCHIVED]: 'Arquivado',
      [ProcessStatusEnum.CONCLUDED]: 'Concluído',
      [ProcessStatusEnum.IN_CORRECTION]: 'Aguardando ajuste do cidadão',
      [ProcessStatusEnum.OUTDATED]: 'Vencido',
      [ProcessStatusEnum.CANCELED]: 'Anulado',
      [ProcessStatusEnum.ANSWERED]: 'Respondido',
      [ProcessStatusEnum.EXPIRED_WITHOUT_ANALYSIS]: 'Vencido sem Análise',
      [ProcessStatusEnum.AWAITING_REFUND]: 'Aguardando restituição',
      [ProcessStatusEnum.PENDING_WITHOUT_RESPONSIBLE]: 'Pendente de Atribuição',
      [ProcessStatusEnum.AWAITING_PAYMENT]: 'Aguardando pagamento',
      [ProcessStatusEnum.APENSADO]: 'Apensado',
      [ProcessStatusEnum.AWAITING_SECRETARY_SIGNATURE]: 'Aguardando assinatura do Secretário'
    };
  
    return statusDescriptions[status] || 'Desconhecido';
  }
  
  getProcessTooltip(status: number): string {
    const statusTooltips = {
      [ProcessStatusEnum.NEW]: '',
      [ProcessStatusEnum.IN_PROGRESS]: 'O processo está em análise. Você será notificado sobre qualquer atualização.',
      [ProcessStatusEnum.ARCHIVED]: 'Seu processo foi finalizado e arquivado pelo departamento responsável.',
      [ProcessStatusEnum.CONCLUDED]: 'O processo foi finalizado. Clique em “Ver” para detalhes sobre a conclusão',
      [ProcessStatusEnum.IN_CORRECTION]: 'O processo requer ajustes. Realize as correções necessárias para prosseguirmos com o atendimento.',
      [ProcessStatusEnum.OUTDATED]: 'O processo foi vencido.',
      [ProcessStatusEnum.CANCELED]: 'Seu processo foi anulado. Clique em ”Ver” para consultar o motivo e obter mais detalhes.',
      [ProcessStatusEnum.ANSWERED]: 'O processo foi respondido pelo cidadão.',
      [ProcessStatusEnum.APENSADO]: 'O processo está apensado.',
      [ProcessStatusEnum.AWAITING_SECRETARY_SIGNATURE]: 'A certidão do processo aguarda a assinatura do(a) Secretário(a) e será disponibilizada logo após.'
    };
  
    return statusTooltips[status];
  }

  handleCollapseRowRequest(index: number) {
      this.isTableHistoryOpen[index] = !this.isTableHistoryOpen[index];
  }

  handleCollapseRowProcess(index: number) {
    this.isTableHistoryOpen[index] = !this.isTableHistoryOpen[index];
}

  public handleNavigate(requestStatus: number, requestId: number) {
      let typeRouter: string = 'view';

      if (!this.userService.isAdmin() && requestStatus === 2) {
          typeRouter = 'edit';
      }

      const encryptedRequestId = this.cryptoService.encrypt(String(requestId));

      this.global.router.navigate([`/requests/${typeRouter}/${encryptedRequestId}`]);
  }

  public handleNavigateToProcess(processId: number) {
      const encryptedId = this.cryptoService.encrypt(String(processId));
      this.global.router.navigate([`/process/view/${encryptedId}`]);
  }

  public get reportButtonRule() {
      return this.userService.isAdmin() || this.userService.isAdmOrgao() || this.userService.isDiretorDepartamento() || this.userService.isSecretario();
  }

  public getProcess(id: number) {
    this.processService.getEntity(id).subscribe({
      next:(response: IGetEntityProccessResponse) => {
        console.log('[getProcess]:', response);
        
      } 
    })
  }

  get isCitizen() {
    return this.userService.isCidadao();
  }

  // ------------------------------------------------------------------
  // Abas, resumo e linhas da lista
  // ------------------------------------------------------------------

  private loadOverview(): void {
    this.requestService.getCitizenOverview().subscribe({
      next: (overview) => (this.overview = overview),
      error: () => (this.overview = null),
    });
  }

  private parseTab(value: string): CitizenTab {
    return (Object.values(RequestBucketEnum) as string[]).includes(value) ? (value as RequestBucketEnum) : 'todas';
  }

  public setTab(tab: CitizenTab): void {
    if (tab === this.activeTab) return;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { aba: tab === 'todas' ? null : tab, [this.pageParam]: null },
      queryParamsHandling: 'merge',
    });
  }

  /** Quantas há na aba, pelo resumo; null enquanto ele não chega. */
  public tabCount(tab: CitizenTab): number | null {
    if (!this.overview) return null;

    return tab === 'todas' ? this.overview.totais.total : this.overview.totais[tab];
  }

  public get firstName(): string {
    const nome = String(this.global.user()?.PE_Nome || '').trim().split(/\s+/)[0] || '';

    return nome.charAt(0).toUpperCase() + nome.slice(1).toLowerCase();
  }

  public get hasActiveFilters(): boolean {
    return this.isClearFiltersButtonVisible || this.activeTab !== 'todas';
  }

  public status(item: any): IRqStatus {
    return citizenStatus(item);
  }

  /** Estado de cada trecho da barra de etapas (Enviada, Análise, Processo, Concluída). */
  public trackState(item: any, index: number): Record<string, boolean> {
    const stage = requestStage(item);
    const concluded = stage.current === this.stages.length - 1 && !stage.stopped;

    return {
      'is-done': index < stage.current || concluded,
      'is-current': index === stage.current && !concluded,
      'is-stopped': index === stage.current && stage.stopped,
      [`is-${stage.tone}`]: index === stage.current,
    };
  }

  public currentStageLabel(item: any): string {
    return this.stages[requestStage(item).current];
  }

  /** Solicitação (não processo) esperando correção: mostra o prazo no lugar da explicação. */
  public correctionDeadline(item: any): string | null {
    return !item?.PRC_NumeroProcesso && item?.SOL_Status === RequestStatusEnum.correction ? item?.SOLC_DataLimiteCorrecao || null : null;
  }

  public open(item: any): void {
    if (item?.PRC_NumeroProcesso) {
      this.handleNavigateToProcess(item.PRC_CodigoProcesso);
    } else {
      this.handleNavigate(item.SOL_Status, item.SOL_CodigoSolicitacao);
    }
  }

  public openPending(pendencia: ICitizenOverviewPending): void {
    if (pendencia.PRC_CodigoProcesso) {
      this.handleNavigateToProcess(pendencia.PRC_CodigoProcesso);
    } else {
      this.handleNavigate(pendencia.SOL_Status, pendencia.SOL_CodigoSolicitacao);
    }
  }

  public trackByItem(_: number, item: any): string {
    return `${item?.SOL_CodigoSolicitacao}-${item?.PRC_CodigoProcesso || ''}`;
  }

  public orgIcon(descricao: string): string {
    return orgIcon(descricao);
  }

  // ------------------------------------------------------------------
  // Pendências
  // ------------------------------------------------------------------

  public openPendingModal(): void {
    this.pendingOpen = true;
    document.body.style.overflow = 'hidden';
    setTimeout(() => this.pendingClose?.nativeElement.focus());
  }

  public closePendingModal(): void {
    this.pendingOpen = false;
    document.body.style.overflow = '';
  }

  @HostListener('document:keydown.escape')
  public onEscape(): void {
    if (this.pendingOpen) this.closePendingModal();
  }

  public showPendingInList(): void {
    this.closePendingModal();
    this.setTab(RequestBucketEnum.ACAO);
  }

  public isOverdue(prazo: string | null): boolean {
    return !!prazo && new Date(prazo).getTime() < Date.now();
  }

  ngOnDestroy(): void {
    document.body.style.overflow = '';
  }

  // ------------------------------------------------------------------
  // Paginação
  // ------------------------------------------------------------------

  public get currentPage(): number {
    return Number(this.pagination?.current_page) || 1;
  }

  public get lastPage(): number {
    return Number(this.pagination?.last_page) || 1;
  }

  /** Números de página com lacunas (null) quando são muitas: 1 2 … 7 8 9 … 20. */
  public get pageNumbers(): Array<number | null> {
    const ultima = this.lastPage;
    const atual = this.currentPage;

    if (ultima <= 7) return Array.from({ length: ultima }, (_, i) => i + 1);

    const visiveis = [1, 2, atual - 1, atual, atual + 1, ultima - 1, ultima]
      .filter((pagina, i, lista) => pagina >= 1 && pagina <= ultima && lista.indexOf(pagina) === i)
      .sort((a, b) => a - b);

    return visiveis.reduce((paginas: Array<number | null>, pagina, i) => {
      if (i > 0 && pagina - visiveis[i - 1] > 1) paginas.push(null);
      paginas.push(pagina);
      return paginas;
    }, []);
  }

  public goToPage(pagina: number): void {
    if (pagina < 1 || pagina > this.lastPage || pagina === this.currentPage) return;

    this.listAll(pagina);
  }
}
